import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connectRange } from 'react-instantsearch-dom'
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers'
import LuxonUtils from '@date-io/luxon'
import { DateTime } from 'luxon'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { PillSelect } from './Refiners.styles'

const CustomRangeInput = (props) => {
  const {
    refine,
  } = props
  const [selectedDate, setSelectedDate] = useState(null)
  const [open] = useState(false)

  const onDateChange = (e) => {
    const startOfDay = e?.ts ? DateTime.fromMillis(e.ts).startOf('day').toUTC().toMillis()
      : DateTime.local().startOf('day').toUTC().toMillis()

    const endOfDay = e?.ts ? DateTime.fromMillis(e.ts).endOf('day').toUTC().toMillis()
      : DateTime.local().startOf('day').plus({ year: 1 }).toUTC()
        .toMillis()

    setSelectedDate(e)

    return refine({
      min: startOfDay / 1000,
      max: endOfDay / 1000,
    })
  }

  const PillInput = ({ value, onChange, onClick }) => {
    return (
      <PillSelect
        variant="outlined"
        value={value || ''}
        onChange={onChange}
        onClick={onClick}
        displayEmpty
        IconComponent={KeyboardArrowDownIcon}
        renderValue={() => value || 'Add Date'}
        open={open}
      />
    )
  }

  return (
    <MuiPickersUtilsProvider utils={LuxonUtils}>
      <DatePicker
        id="start-date"
        name="startDate"
        label="Add Date"
        value={selectedDate}
        format="MMM dd, yyyy"
        onChange={onDateChange}
        disablePast
        fullWidth
        clearable
        TextFieldComponent={PillInput}
      />
    </MuiPickersUtilsProvider>
  )
}

CustomRangeInput.propTypes = {
  refine: PropTypes.func,
}

export default connectRange(CustomRangeInput)
